module.exports = __webpack_public_path__ + "img/scene3-1.323db0e1.jpg";